import React, { PropsWithChildren } from 'react'
import { ScrollContextProvider } from 'src/lib/scroll/ScrollContext'

const ProviderAny = ScrollContextProvider as unknown as React.ComponentType<any>

type Props = PropsWithChildren<{ offset: number }>
export const WithScroll: React.FC<Props> = ({ offset, children }) => (
    <ProviderAny offset={offset}>{children}</ProviderAny>
)
